// Machine-authored for Phase 8; requires review by a native Arabic speaker.
const subscriptions = {
  moduleTitle: "الاشتراكات",
  actions: {
    view: "عرض الاشتراكات",
    create: "إنشاء اشتراك",
    update: "تحديث اشتراك",
    delete: "حذف اشتراك",
  },
  permissions: {
    core: "النواة",
    management: "إدارة الاشتراكات",
    subscriptions: "الاشتراكات",
  },
  listTitle: "الاشتراكات",
  listSubtitle: "إدارة الاشتراكات",
  create: "إنشاء اشتراك",
  filters: {
    title: "تصفية الاشتراكات",
    filters: "التصفية",
    search: "البحث في الاشتراكات",
    searchPlaceholder: "ابحث حسب المشترك",
    subscriber: "المشترك",
    subscriberPlaceholder: "كل المشتركين",
    subscriberSearch: "ابحث عن مشترك",
    subscriberEmpty: "لا يوجد مشتركون.",
    clearSubscriber: "مسح المشترك",
    status: "الحالة",
    allStatuses: "كل الحالات",
    activeOnly: "النشط فقط",
    createdAt: "تاريخ الإنشاء",
    createdAtPlaceholder: "اختر نطاقاً زمنياً",
    clearDateRange: "مسح النطاق الزمني",
  },
  datePicker: {
    nextMonth: "الشهر التالي",
    previousMonth: "الشهر السابق",
  },
  table: {
    subscriber: "المشترك",
    modules: "الأنظمة",
    moreModules: "{{count}} أنظمة أخرى",
    totalPrice: "السعر الإجمالي",
    status: "الحالة",
    createdAt: "تاريخ الإنشاء",
    actions: "الإجراءات",
    empty: "لا توجد اشتراكات مطابقة لهذه التصفية.",
    error: "تعذر تحميل الاشتراكات.",
    loading: "جارٍ تحميل الاشتراكات",
    showing: "عرض {{count}} من {{total}}",
    rowsPerPageLabel: "عرض الصفوف",
    next: "الصفحة التالية",
    previous: "الصفحة السابقة",
    pagination: "ترقيم الصفحات",
    sortAscending: "ترتيب تصاعدي",
    sortDescending: "ترتيب تنازلي",
  },
  status: {
    active: "نشط",
    inactive: "غير نشط",
    expired: "منتهي",
    scheduled: "مجدول",
  },
  actionMenu: {
    trigger: "إجراءات الاشتراك",
    view: "عرض التفاصيل",
  },
  form: {
    createTitle: "إنشاء اشتراك",
    backToDetail: "العودة إلى الاشتراك",
    addModulesTitle: "إضافة أنظمة",
    createSuccess: "تم إنشاء الاشتراك بنجاح.",
    updateSuccess: "تم تحديث الاشتراك بنجاح.",
    subtitle: "اختر المشترك وتفاصيل النظام.",
    catalogUnavailable: "وحدة الكتالوج غير متاحة، لذلك لا يمكن إضافة الأنظمة.",
    companiesUnavailable:
      "وحدة الشركات غير متاحة، لذلك لا يمكن اختيار المشترك.",
    subscriberId: "المشترك",
    selectInstitution: "اختيار الشركة",
    subscriberPlaceholder: "اختر الشركة",
    featureId: "النظام",
    modulePlaceholder: "معرّف النظام",
    purchasingPrice: "سعر الشراء",
    noPeriod: "بدون مدة (لا تنتهي)",
    dateRange: "مدة الاشتراك",
    dateRangePlaceholder: "اختر تاريخ البدء والانتهاء",
    selectDatePlaceholder: "اختر التاريخ",
    clearDateRange: "مسح نطاق التاريخ",
    nextMonth: "الشهر التالي",
    previousMonth: "الشهر السابق",
    deviceTypes: "أنواع الأجهزة",
    deviceTypesSubtitle:
      "إضافة أنواع الأجهزة المصرح للشركة باستخدامها ضمن هذا العقد.",
    systemsSubtitle:
      "اختر الأنظمة المشمولة في هذا الاشتراك. يمكن تعديل الأسعار حسب الحاجة.",
    currentModules: "الأنظمة الحالية",
    currentModulesSubtitle:
      "أنظمة مضافة بالفعل إلى هذا الاشتراك. تُعرض للاطلاع فقط ولا يمكن تعديلها هنا.",
    assignableSubtitle:
      "لا يمكن إضافة سوى الأنظمة غير المضافة إلى هذا الاشتراك.",
    noAssignableModules: "لا توجد أنظمة متاحة لإضافتها إلى هذا الاشتراك.",
    addDeviceType: "إضافة نوع جهاز",
    removeDeviceType: "حذف نوع الجهاز",
    modulesRequired: "يجب اختيار نظام واحد على الأقل.",
    capacity: {
      label: "سعة {{name}}",
      total: "إجمالي العدد",
      used: "الأعداد المستخدمة",
      remaining: "الأعداد المتبقية",
      unlimited:
        "سعة هذا النظام غير محدودة، ويمكنك إضافة المستخدمين دون استهلاك السعة المخصصة أو التأثير عليها.",
    },
    save: "حفظ",
    cancel: "إلغاء",
  },
  detail: {
    loading: "جارٍ تحميل الاشتراك",
    backToList: "العودة إلى الاشتراكات",
    error: "تعذر تحميل الاشتراك.",
    modules: "الأنظمة",
    purchasingPrice: "سعر الشراء",
    price: "السعر",
    addFeatures: "إضافة أنظمة",
    subtitle: "إنشاء الاشتراك وتحديد حدود التراخيص الخاصة بالشركة",
    edit: "تعديل",
    tabs: {
      upcoming: "القادم",
      current: "الحالي",
      previous: "السابق",
    },
    companyDetails: "تفاصيل الشركه",
    institutionName: "اسم الشركه",
    devices: "الأجهزه",
    deviceType: "نوع الجهاز",
    deviceModel: "موديل الجهاز",
    quantity: "الكميه",
    duration: "المده",
    noDevices: "لا توجد أجهزة مخصصة لهذا الاشتراك.",
    systems: "الانظمه",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    noModules: "لا توجد أنظمة في هذا القسم.",
  },
  duration: {
    annual: "سنوي",
    semiAnnual: "نصف سنوي",
    monthly: "شهري",
    days: "{{count}} يوم",
    noPeriod: "بدون مدة",
  },
  validation: {
    required: "هذا الحقل مطلوب.",
    price: "أدخل سعراً صحيحاً غير سالب.",
    priceRequired: "سعر الشراء مطلوب لهذا النظام.",
    dateRange: "اختر تاريخ بدء وتاريخ انتهاء.",
    invalidPeriod: "يجب أن تكون المدة 1 أو 3 أو 6 أو 9 أو 12 شهراً بالضبط.",
  },
};
export default subscriptions;
